
import { Vue } from "vue-class-component";

export default class OutgoingCurrentStt extends Vue {}
